import { lazy } from 'react'

const RELOAD_FLAG = 'hiq:chunk-reloaded'

export function isChunkLoadError(err) {
  const msg = String(err?.message || err || '')
  return (
    msg.includes('Failed to fetch dynamically imported module') ||
    msg.includes('error loading dynamically imported module') ||
    msg.includes('Importing a module script failed') ||
    msg.includes('Loading chunk')
  )
}

// Wraps React.lazy with a one-shot, session-scoped reload on chunk-load
// failure. After a deploy the user's cached index.html still references
// old chunk hashes; navigating to a route that lazy-loads a now-404'd
// chunk rejects the import promise. We catch that exact failure once
// per session, drop a sessionStorage breadcrumb so we can't loop-
// reload on a genuinely broken new build, and force a hard refresh to
// pick up the new index.html. Non-chunk errors propagate to the
// nearest ErrorBoundary unchanged.
export function lazyWithReload(factory) {
  return lazy(() =>
    factory().catch((err) => {
      if (!isChunkLoadError(err)) throw err
      if (sessionStorage.getItem(RELOAD_FLAG)) throw err
      try {
        sessionStorage.setItem(RELOAD_FLAG, '1')
      } catch {
        /* private mode — guard absent, the reload still fires once */
      }
      window.location.reload()
      // Return a never-resolving promise so React doesn't paint a
      // fallback in the brief window before the reload kicks in.
      return new Promise(() => {})
    }),
  )
}
